import { ExclamationCircleOutlined } from "@ant-design/icons";
import { uploadViaBackend } from "../helper/uploadViaBackend";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Table,
  Tag,
} from "antd";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import "react-phone-input-2/lib/style.css";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { Severty, ShowToast } from "../helper/toast";
import useDebounce from "../hooks/useDebounce";
import useRequest from "../hooks/useRequest";

import { Select } from "antd";
const { Option } = Select;

const { RangePicker } = DatePicker;

const Search = Input.Search;
let baseURL = "/admin/code";

function Codes({ type }) {
  const { userPermission, userProfile } = useContext(AuthContext) || {
    userPermission: [],
  };
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [searchText, setSearchText] = useState("");
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [listExport, setListExport] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleView, setVisibleView] = useState(false);
  const [provideSession, setProvideSession] = useState(false);
  const [selected, setSelected] = useState();
  const [viewData, setViewData] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [filter, setFilter] = useState();
  const [isRKModalVisible, setIsRKModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [rowFilter, setRowFilter] = useState({});
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState([]);
  const [isCustomerDetailsVisible, setIsCustomerDetailsVisible] =
    useState(false);
  const [file, setFile] = useState([]);
  const [certificateModalVisible, setCertificateModalVisible] = useState(false);
  const [certificateCP, setCertificateCP] = useState(null);
  const [image, setImage] = useState(null);
  const FileType = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/webp",
    "application/pdf",
    "application/msword", // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];
  const statusLabelMap = {
    used: "Used",
    unused: "Unused",
  };
  const columns = [
    {
      title: "Code",
      render: (_, { code }) => {
        return <div>{code}</div>;
      },
    },
    {
      title: "Status",
      key: "isUsed",
      render: (_, { isUsed }) => {
        return (
          <Tag color={isUsed ? "red" : "green"} style={{ cursor: "default" }}>
            {isUsed ? "Used" : "Unused"}
          </Tag>
        );
      },
    },
    {
      title: "Created date",
      key: "createdAt",
      dataIndex: "createdAt",
      render: (_, { createdAt }) => {
        return new Date(createdAt).toLocaleDateString();
      },
    },
    {
      title: "Assigned User",
      render: (_, { userId }) => {
        return <div>{userId?.[0]?.name}</div>;
      },
    },
    {
      title: "Action",
      render: (_, record) => {
        return (
          <>
            <div className="cta_wrap">
              <Button
                danger
                style={{ marginLeft: 8 }}
                title="Delete"
                onClick={() => {
                  Modal.confirm({
                    // title: "Are you sure you want to delete this practitioner?",
                    content: "Are you sure you want to delete this Code?",
                    icon: <ExclamationCircleOutlined />,
                    okText: "Yes",
                    cancelText: "No",
                    onOk: () => deleteAccount(record),
                  });
                }}
              >
                <i className="fa fa-trash"></i>
              </Button>
            </div>
          </>
        );
      },
    },
  ];
  useEffect(() => {
    if (certificateModalVisible && certificateCP?.certifications) {
      setImage(certificateCP.certifications); // assume this is the URL
    }
  }, [certificateModalVisible, certificateCP]);
  const uploadFileToS3 = async (file) => {
    // Uploads go through the backend (no S3 keys in the browser).
    return await uploadViaBackend(file, "realState/admin");
  };

  const handleChangeImage = async (event) => {
    const { file } = event;
    let validateImage =
      file.type.includes("image") && !file.type.includes("svg");

    if (!validateImage) {
      return ShowToast("media not supported " + file.type, Severty.ERROR);
    }
    setFile([file]);
    try {
      const data = await uploadFileToS3(file, "invent-colab-obj-bucket");
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: data.Location,
        thumbUrl: data.Location,
      };
      setFile([fileData]);
    } catch (err) {
      console.error(err);
    }
  };

  const debouncedSearchText = useDebounce(searchText, 300);

  const navigate = useNavigate();
  const { confirm } = Modal;

  const deleteAccount = (record) => {
    // alert(record._id)
    request({
      url: `${baseURL}/delete-account/${record ? record._id : ""}`,
      method: "PUT",
      onSuccess: (data) => {
        console.log(data, "data");
        setRefresh(!refresh);
        setLoading(false);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error?.response?.data?.message, Severty.ERROR);
      },
    });
  };

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1, pageSize: pagination.pageSize });
  };

  const statusChange = (record) => {
    setLoading(true);
    request({
      url: `${baseURL}/status-change/${record}?`,
      method: "PUT",
      onSuccess: (data) => {
        setRefresh((prev) => !prev);
        setLoading(false);
        ShowToast(data?.message, Severty.SUCCESS);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error?.response?.data?.message, Severty.ERROR);
      },
    });
  };

  const showConfirm = (record) => {
    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: <Button>Are you sure you want change the status ? </Button>,
        onOk() {
          statusChange(record);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  useEffect(() => {
    setLoading(true);
    fetchData(pagination);
  }, [refresh, debouncedSearchText, startDate, endDate]);

  useEffect(() => {
    if (!visibleView) return;
    navigate(`/view-customer/${viewData._id}`);
  }, [visibleView]);

  const handleChange = (pagination, filters) => {
    setRowFilter(filters);
    fetchData(pagination, filters);
  };

  const fetchData = (pagination, filters) => {
    const filterActive = filters ? filters.isActive : rowFilter.isActive;
    request({
      url: `${baseURL}/list?status=${
        filterActive ? filterActive.join(",") : ""
      }&page=${pagination ? pagination.current : 1}&limit=${
        pagination ? pagination.pageSize : 10
      }&search=${debouncedSearchText}&start_date=${
        startDate ? startDate : ""
      }&end_date=${endDate ? endDate : ""}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data.list.docs);
        setPagination((prev) => ({
          current: pagination.current,
          total: data.data.list.totalDocs,
          pageSize: pagination.pageSize ?? 10,
        }));
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error?.response?.data?.message, Severty.ERROR);
      },
    });
  };

  const handleImage = (data) => {
    const url = data?.[0]?.url || "";
    setImage(url);
  };

  const handleChangeDate = (e) => {
    setStartDate();
    setEndDate();
    if (e && e.length > 0) {
      setStartDate(moment(e[0]._d).format("YYYY-MM-DD"));
      setEndDate(moment(e[1]._d).format("YYYY-MM-DD"));
    }
  };

  const handleCertificationSubmit = (values) => {
    const payload = { image: image };

    request({
      url: `${baseURL}/certifications/${values}`,
      method: "POST",
      data: payload,
      onSuccess: (res) => {
        ShowToast("Certification submitted successfully!", Severty.SUCCESS);
        fetchData(pagination); // Refresh the data after submission
      },
    });

    setImage(null); // Reset image after submission
  };

  return (
    <>
      <div className="tabled">
        <Row>
          <Col span={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Codes Management"
              extra={
                <>
                  <Button
                    onClick={(e) => {
                      setVisible(true);
                      setSearchText("");
                    }}
                  >
                    Add Code
                  </Button>
                </>
              }
            >
              <div className="table-responsive">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{
                    current: pagination?.current,
                    defaultPageSize: 10,
                    responsive: true,
                    total: pagination.total,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSizeOptions: ["10", "20", "30", "50"],
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      <AddForm
        file={file}
        setFile={setFile}
        handleChangeImage={handleChangeImage}
        show={visible}
        hide={() => {
          setSelected();
          setVisible(false);
          setSearchText("");
        }}
        data={selected}
        refresh={() => setRefresh((prev) => !prev)}
      />
    </>
  );
}

const AddForm = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState(null);
  const [signature, setSignature] = useState(null);
  const [mfList, setMfList] = useState([]);
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [selectedMF, setSelectedMF] = useState([]);
  const FileType = ["image/png", "image/jpg", "image/jpeg", "image/webp"];
  const selectedMFList = Form.useWatch("masterFacilitator", form);
  const selectedCPList = Form.useWatch("certifiedPractitioner", form);

  useEffect(() => {
    const fetchAssignedUsers = async () => {
      try {
        const res = request({
          url: `${baseURL}/userList`,
          method: "GET",
          onSuccess: (res) => {
            const mfArray = [];
            const cpArray = [];
            res?.data?.list.map((user) => {
              console.log(user.type, "=================== user.type");
              if (user.type === "master_facilitator") {
                mfArray.push(user);
              } else if (user.type === "certified_practitioner") {
                cpArray.push(user);
              }
            });
            setMfList(mfArray);
            setAssignedUsers(cpArray);
            console.log("master_facilitator", mfArray);
            console.log("certified_practitioner", cpArray);
            //  setAssignedUsers(res?.data?.list);
          },
          onError: (error) => {
            setLoading(false);
            ShowToast(error?.response?.data?.message, Severty.ERROR);
          },
        });
      } catch (err) {
        setLoading(false);
        ShowToast("Internal Server Error", Severty.ERROR);
      }
    };

    fetchAssignedUsers();
  }, []);

  // Populate form for edit
  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        ...data,
        profileImage: data?.image,
        signature: data?.signature,
        master_practitioner: Array.isArray(data.master_practitioner)
          ? data.master_practitioner.map((mp) =>
              typeof mp === "object" ? mp._id : mp
            )
          : [],
      });
      setImage(data?.image || null);
      setSignature(data?.signature || null);
    }
  }, [data]);

  const onCreate = (values) => {
    console.log("values=============", values);
    if (!values.code) {
      return ShowToast("Code is required", Severty.ERROR);
    }
    if (!values.masterFacilitator && !values.certifiedPractitioner) {
      return ShowToast(
        "Please select a user to assign the code",
        Severty.ERROR
      );
    }
    const userId = [];
    if (values.masterFacilitator) {
      userId.push(values.masterFacilitator);
    }
    if (values.certifiedPractitioner) {
      userId.push(values.certifiedPractitioner);
    }
    const payload = {
      code: values.code,
      userId: userId,
    };

    request({
      url: data ? `${baseURL}/edit-user/${data._id}` : `${baseURL}/add`,
      method: data ? "PUT" : "POST",
      data: payload,
      onSuccess: (res) => {
        ShowToast(res.message, Severty.SUCCESS);
        hide();
        refresh();
        form.resetFields();
      },
      onError: (err) => {
        ShowToast(err.response.data.message, Severty.ERROR);
      },
    });
  };

  return (
    <Modal
      open={show}
      onCancel={hide}
      title={data ? "Edit Certified Practitioner" : "Add Code"}
      okButtonProps={{ form: "add-mf-form", htmlType: "submit", loading }}
    >
      <Form id="add-mf-form" layout="vertical" form={form} onFinish={onCreate}>
        {/* Full Name */}
        <Form.Item
          label="Enter a code"
          name="code"
          rules={[
            {
              required: true,
              message: "Code is required",
            },
            {
              pattern: /^[A-Z]+[0-9]*$/,
              message:
                "Only uppercase letters followed optionally by digits (e.g., JOHN001)",
            },
          ]}
        >
          <Input placeholder="Enter Code (e.g., JOHN001)" />
        </Form.Item>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="masterFacilitator" label="Master Facilitator">
              <Select
                placeholder="Select Master Facilitator User"
                allowClear
                disabled={!!selectedCPList}
              >
                {mfList
                  ?.filter((user) => user?.isActive)
                  ?.map((user) => (
                    <Select.Option key={user?._id} value={user?._id}>
                      {user?.name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="certifiedPractitioner"
              label="Certified Practitioner"
            >
              <Select
                placeholder="Select Certified Practitioner User"
                allowClear
                disabled={!!selectedMFList}
              >
                {assignedUsers.map((user) => (
                  <Select.Option key={user._id} value={user._id}>
                    {user.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default Codes;
